import { useHeartbeat } from '@/api/locations/useHeartbeat';
import { CountIndicator } from '@/components/Badges/CountIndicator';

export const WaitingBadge = () => {
  const { waiting } = useHeartbeat();
  return <CountIndicator count={waiting} />;
};
